export const COLOR_VARS = {
  SWIFT_COLOR1: "var(--SWIFT_COLOR1)",
  SWIFT_COLOR2: "var(--SWIFT_COLOR2)",
  SWIFT_COLOR3: "var(--SWIFT_COLOR3)",
  SWIFT_COLOR4: "var(--SWIFT_COLOR4)",
  SWIFT_COLOR5: "var(--SWIFT_COLOR5)",
  SWIFT_COLOR6: "var(--SWIFT_COLOR6)",
  SWIFT_COLOR7: "var(--SWIFT_COLOR7)",
  SWIFT_COLOR8: "var(--SWIFT_COLOR8)",
};